import React from 'react';

export const DocumentUpload = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_4420_3929)">
      <path
        d="M17.5 23.501C20.8137 23.501 23.5 20.8147 23.5 17.501C23.5 14.1873 20.8137 11.501 17.5 11.501C14.1863 11.501 11.5 14.1873 11.5 17.501C11.5 20.8147 14.1863 23.501 17.5 23.501Z"
        stroke="#3399B5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.5 20.501V14.501" stroke="#3399B5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5 14.501L15.25 16.751" stroke="#3399B5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5 14.501L19.75 16.751" stroke="#3399B5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 6.50098H13.5" stroke="#3399B5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 10.501H9.5" stroke="#3399B5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.5 14.501H7.25" stroke="#3399B5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.25 20.501H2C1.60218 20.501 1.22064 20.3423 0.93934 20.061C0.658035 19.7797 0.5 19.3988 0.5 19.001V2.00098C0.5 1.60315 0.658035 1.22162 0.93934 0.940316C1.22064 0.659012 1.60218 0.500977 2 0.500977H12.129C12.5265 0.501061 12.9078 0.658958 13.189 0.939977L16.061 3.81198C16.342 4.09317 16.4999 4.47443 16.5 4.87198V7.25098"
        stroke="#3399B5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4420_3929">
        <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)" />
      </clipPath>
    </defs>
  </svg>
);
